import React, { PureComponent } from 'react';
import { withTranslation, TFunction } from 'react-i18next';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import styled from 'styled-components';
import { emptyFunction } from '../../core/util/function';
import { LinkButton } from './Button/BaseButton';
import { colors } from '../../constants/colors';
import { fontFamily, fontSize } from '../../constants/text';

const StyledDialog = styled(Dialog).withConfig({ componentId: 'sc-24t2b1-0' })`
  border-radius: 8px;
`;

const StyledTitle = styled(DialogTitle).withConfig({ componentId: 'sc-24t2b1-1' })`
  font-family: ${fontFamily.bold};
  font-size: ${fontSize.large};
  letter-spacing: 0.69px;
  line-height: 28px;
  color: ${colors.fadeToBlack};
`;

const StyledDescription = styled(DialogContentText).withConfig({ componentId: 'sc-24t2b1-2' })`
  color: ${colors.lightText};
`;

const StyledCtaButton = styled(LinkButton).withConfig({ componentId: 'sc-24t2b1-3' })`
  font-family: ${fontFamily.bold};
  font-size: ${fontSize.mediumSmall};
  letter-spacing: 0.13px;
  line-height: 36px;
`;

type OwnProps = {
  description: string;
  title: string;
  className?: string;
  trackEvent?: (...args: any[]) => any;
  isOpen?: boolean;
  onClose?: (...args: any[]) => any;
  onClickCtaLeft?: (...args: any[]) => any;
  onClickCtaRight?: (...args: any[]) => any;
  t: TFunction<'common'>;
};

type Props = OwnProps & typeof ErrorMessageDialog.defaultProps;

class ErrorMessageDialog extends PureComponent<Props> {
  static defaultProps = {
    onClose: emptyFunction,
  };

  render() {
    const { onClose, description, title, isOpen, onClickCtaLeft, onClickCtaRight, t } = this.props;
    return (
      <StyledDialog
        aria-describedby="alert-dialog-description"
        aria-labelledby="alert-dialog-title"
        disableAutoFocus
        onClose={onClose}
        // @ts-expect-error ts-migrate(2769) FIXME: Type 'undefined' is not assignable to type 'boolea... Remove this comment to see the full error message
        open={isOpen}
      >
        <StyledTitle disableTypography id="alert-dialog-title">
          {title}
        </StyledTitle>

        <DialogContent>
          <StyledDescription id="alert-dialog-description">{description}</StyledDescription>
        </DialogContent>

        <DialogActions>
          <StyledCtaButton onClick={onClickCtaLeft}>{t('tryAgain.uppercase')}</StyledCtaButton>

          <StyledCtaButton onClick={onClickCtaRight}>{t('continue.uppercase')}</StyledCtaButton>
        </DialogActions>
      </StyledDialog>
    );
  }
}

export default withTranslation()(ErrorMessageDialog);
